import { useStatPermissionsBaseQuery } from './use-stat-permissions-base-query';
import { useStatPermissionsEmployeeQuery } from './use-stat-permissions-employee-query';
import { useStatPermissionsChildQuery } from './use-stat-permissions-child-query';
import { useStatPermissionsFormQuery } from './use-stat-permissions-form-query';
import { useStatPermissionsRatioInfoQuery } from './use-stat-permissions-ratio-info-query';
export function useStatPermissionsQuery(options) {
    const siteSetId = options.variables.siteSetId;
    const institutionSetId = siteSetId; // They are the same according to user
    const employeeId = options.variables.employeeId;
    const childId = options.variables.childId;
    const formId = options.variables.formId;
    const ratioCalculationConfig = options.variables.ratioCalculationConfig;
    // Always fetch base permissions
    const base = useStatPermissionsBaseQuery({
        skip: options.skip || !siteSetId,
        variables: {
            siteSetId,
            institutionSetId,
            employeeId,
        },
    });
    // Always call hooks, but conditionally skip them
    const employee = useStatPermissionsEmployeeQuery({
        skip: !employeeId || options.skip,
        variables: {
            siteSetId,
            employeeId: employeeId || '',
        },
    });
    const child = useStatPermissionsChildQuery({
        skip: !childId || options.skip,
        variables: {
            childId: childId || '',
        },
    });
    const form = useStatPermissionsFormQuery({
        skip: !formId || options.skip,
        variables: {
            siteSetId,
            formId: formId || '',
        },
    });
    const ratioInfo = useStatPermissionsRatioInfoQuery({
        skip: options.skip || !siteSetId || !ratioCalculationConfig,
        variables: {
            siteSetId,
            calculationConfig: ratioCalculationConfig,
        },
    });
    return {
        base,
        employee: employeeId ? employee : undefined,
        child: childId ? child : undefined,
        form: formId ? form : undefined,
        ratioInfo,
    };
}
